import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(private http: HttpClient) { }
  get(slug) {
    return this.http.get<any>(`/salary_survey/api/site/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getMedia(slug) {
    return this.http.get<any>(`/salary_survey/api/site/media/${slug}`)
      .pipe(map(data => {
        return data;
      }));
  }

  getHomeMedia(slug) {
    return this.http.get<any>(`/salary_survey/api/site/homemedia/${slug}`)
      .pipe(map(data => {
        return data;
      }));
  }

  getDutyStation(slug) {
    return this.http.get<any>(`/salary_survey/api/site/dutyStationList/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getSalaryScale(slug) {
    return this.http.get<any>(`/salary_survey/api/site/salaryScaleList/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }


  getSalaryScaleWithDutyStationId(id) {
    return this.http.get<any>(`/salary_survey/api/site/getSalaryScaleWithDutyStationId/${id}`)
      .pipe(map(result => {
        return result;
      }));
  }



  getResourcesList(slug) {
    return this.http.get<any>(`/salary_survey/api/site/resourcesList/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getResourcesDocsList(slug) {
    return this.http.get<any>(`/salary_survey/api/site/resourcesDocsList/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getTrainingList(slug, pageNo, limit, sortBy = 'nextWorkshopDate', order = -1) {
    return this.http.get<any>(`/salary_survey/api/site/trainingList/${slug}?skip=${(pageNo) * limit}&limit=${limit}&sortBy=${sortBy}&order=${order}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getTrainingDocsList(slug) {
    return this.http.get<any>(`/salary_survey/api/site/trainingDocsList/${slug}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getSpecialMeasuresList(pageNo, limit, sortBy = 'sequence', order = 1) {
    return this.http.get<any>(`/salary_survey/api/site/special-measures?skip=${(pageNo) * limit}&limit=${limit}&sortBy=${sortBy}&order=${order}`);
  }

  getSurveyScheduleList(pageNo, limit, sortBy = 'dutyStationId.name', order = 1) {
    return this.http.get<any>(`/salary_survey/api/site/surveySchedule/list?skip=${(pageNo) * limit}&limit=${limit}&sortBy=${sortBy}&order=${order}`)
      .pipe(map(result => {
        return result;
      }));
  }

  loadSurveyScheduleList(pageNo, limit, sortBy = 'dutystation_info.name', order = 1) {
    return this.http.get<any>(`/salary_survey/api/site/surveySchedule_aggregate/list?skip=${(pageNo) * limit}&limit=${limit}&sortBy=${sortBy}&order=${order}`)
      .pipe(map(result => {
        return result;
      }));
  }
}
